import { Radio } from 'antd';
import type { OperatorSwitchProps } from './types';
import type { ReactElement } from 'react';

export function OperatorSwitch({ value, options, onChange }: OperatorSwitchProps): ReactElement {
  return (
    <Radio.Group value={value} onChange={onChange}>
      {options.map(optionItem => (
        <Radio.Button value={optionItem.value} key={optionItem.label}>
          {optionItem.label}
        </Radio.Button>
      ))}
    </Radio.Group>
  );
}
